import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiHandlerService } from '../api-handler.service';

declare let $:any;
@Component({
  selector: 'app-webinar',
  templateUrl: './webinar.component.html',
  styleUrls: ['./webinar.component.css']
})
export class WebinarComponent implements OnInit {

  constructor(private fb: FormBuilder, private apiService: ApiHandlerService) { }

  eventRegister:FormGroup;
  submit:boolean = false;

  eventInfo: any = {
    _id: null,
    title: null,
    aboutEvent: null,
    bannerImage: null,
    video: null,
    startTime: null,
    endTime: null,
    duration: null,
    eventKeys: null,
    learnerThought: [],
    instructor: null,
    instructorBio: null
  }

  isRegVisible:Boolean = false;
  phoneValid: Boolean = false;

  get email(){
    return this.eventRegister.get('email');
  }
  get userName(){
    return this.eventRegister.get('userName');
  }
  get phone(){
    return this.eventRegister.get('phone');
  }

  ValidateEmail(mail:string) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)){
      return (true)
    }
      return (false)
  }

  validate0to9digit(event: any) {
    this.phoneValid = this.eventRegister.value.phone.length == 9;    
    return (event.charCode >= 48 && event.charCode <= 57)
  }

  get registerFormControl() {
    return this.eventRegister.controls;
  }

  ngOnInit() {    
    $(window).scrollTop(0, 0)
    const lastSegment = window.location.pathname.substring(window.location.pathname.lastIndexOf("/") + 1);
    this.getEventDetails(lastSegment);
    this.eventRegister = this.buildUserForm();
  }

  getEventDetails(slug:string){
    this.apiService.getEventDetails(slug).subscribe(
      (res:any) => {
        if(res.success){
          this.eventInfo = res.data;
          this.isRegVisible = new Date(this.eventInfo.endTime) > new Date();
        }
      },
      (err) => {

      }
    )
  }  

  buildUserForm(): FormGroup{
    return this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      userName: ['', [Validators.required, Validators.pattern('^\\s*[a-zA-Z ]*\\s*$')]],
      phone: ['', [Validators.required]],
      timezone: [Intl.DateTimeFormat().resolvedOptions().timeZone]
    })
  }

  registerUserForEvent(){
    this.submit = true;
    this.eventRegister.value.userName = this.eventRegister.value.userName.trim();
    this.eventRegister.value.email = this.eventRegister.value.email.trim();
    this.eventRegister.value.phone = this.eventRegister.value.phone.trim(); 
    this.eventRegister.value.eventId = this.eventInfo._id;
    this.phoneValid = this.eventRegister.value.phone.length == 10;    
    if(this.eventRegister.valid && this.phoneValid){
      if(!this.eventRegister.value.timezone){
        this.eventRegister.value.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      }
      if(!this.eventRegister.value.userName){
        return alert("Please enter your name!")
      }
      if(!this.ValidateEmail(this.eventRegister.value.email)){
        return alert("Please enter a valid email!")
      }
      this.apiService.registerEventsService(this.eventRegister.value).subscribe(
        (res:any) => {
          alert("Thank you for submitting the form, Please check your email for further information!");
          this.submit = false;
          this.eventRegister.reset();
        },
        (err) =>{

        }
      )
    }
  }

}
